import { htmlDecode } from 'js-htmlencode'
import { useArticleContext } from '../../_core/useArticleContext'
import { length, substr } from 'stringz'
import { OG_TITLE_MAX_LENGTH, OG_DESCRIPTION_MAX_LENGTH } from '../_shared'
import { ArticleContentItemShape } from '../../text-input/content-input/version-a/content-input.models'

export const getDefaultOgDescription = (content: ArticleContentItemShape[], maxLength: number) => {
  const allowedTypes = ['header', 'paragraph']
  const removeTags = (string: string) => {
    return string
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim()
  }
  let result = ''
  if (content?.length > 0) {
    for (const item of content) {
      if (allowedTypes.indexOf(item?.type) !== -1) {
        // @ts-expect-error TS 沒辦法 infer 型別出來 😢
        const pureText = removeTags(htmlDecode(item?.data?.text ?? ''))
        result += `${pureText} `
        if (length(result) > maxLength) {
          result = substr(result, 0, maxLength)
          break
        }
      }
    }
  }
  return result.trim()
}

export const useDefaultOgText = () => {
  const { articleState: { content = '', title = '' } = {} } = useArticleContext()

  return {
    defaultOgTitle: substr(title, 0, OG_TITLE_MAX_LENGTH),
    defaultOgDescription: getDefaultOgDescription(content, OG_DESCRIPTION_MAX_LENGTH),
  }
}
